import { Branded } from '@cotera/utilities';
import {
  derive,
  decode,
  validate,
  derivePrefixForColumn,
  forConversation,
} from './run-keys.impl';
import { Result } from 'neverthrow';

/**
 * Helpers for creating ATC Run Keys.
 */

export interface RunKeyHelpers {
  derive: (keyParams: RunKeyInfo) => RunKey;
  decode: (key: RunKey) => RunKeyInfo;
  validate: (input: string) => Result<RunKey, { t: string; message?: string }>;
  derivePrefixForColumn: (relIdentity: string, colIdentity: string) => RunKey;
  forConversation: (conversationId: string) => RunKey;
}

/**
 * Follows either format:
 *
 * ```typescript
 *
 * `workflow-program-repl|${eraQLHash}`
 *
 * `workflow-program-row|${datasetIdentity}|${columnIdentity}|${stableId}`
 *
 * ```
 */
export type RunKey = Branded<string, 'atc-run-key'>;

export type RunKeyInfo =
  | {
      readonly t: 'workflow-program-repl';
      readonly eraQLHash: string;
    }
  | {
      readonly t: 'workflow-program-row';
      readonly relIdentity: string; // not strictly needed for idempotency but helpful for prefix searching
      readonly colIdentity: string;
      readonly stableId: string;
    }
  | {
      readonly t: 'conversation';
      readonly conversationId: string;
    };

export const RunKeyHelpers: RunKeyHelpers = Object.freeze({
  derive,
  decode,
  validate,
  derivePrefixForColumn,
  forConversation,
});
